import { render, staticRenderFns } from "./FourOhFourPage.vue?vue&type=template&id=aba1bc76&scoped=true"
import script from "./FourOhFourPage.vue?vue&type=script&lang=js"
export * from "./FourOhFourPage.vue?vue&type=script&lang=js"
import style0 from "./FourOhFourPage.vue?vue&type=style&index=0&id=aba1bc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba1bc76",
  null
  
)

export default component.exports